type PartialCart = {
  cartDeliveries: {
    deliveryDate: string;
  }[];
};

type PartialCatalog = {
  eligibleDeliveryDates: string[];
};

/**
 * Get the CartDelivery (from the given Cart) for the same date as the given Catalog, if one exists.
 */
export function getCartDelivery<T extends PartialCart>(
  cart: T,
  catalog: PartialCatalog,
): T['cartDeliveries'][number] | null {
  // Compare full-date (YYYY-MM-DD) strings to see if they are the same day
  const cartDeliveryIndex = cart.cartDeliveries.findIndex((cartDelivery) => {
    return catalog.eligibleDeliveryDates.includes(cartDelivery.deliveryDate);
  });

  if (cartDeliveryIndex === -1) {
    return null;
  }

  return cart.cartDeliveries[cartDeliveryIndex];
}

// slimmed down version of a cart for util function purposes
type CartDeliveryWithLineItemAndQuantities = {
  lineItems?: { quantity: number }[];
};

export const getTotalCartMeals = (
  cartDeliveries: CartDeliveryWithLineItemAndQuantities[],
) => {
  return cartDeliveries.reduce(
    (cumulativeCountOfMeals: number, cartDelivery) => {
      const numMealsForCartDelivery =
        cartDelivery.lineItems?.reduce(
          (total: number, lineItem) => total + lineItem.quantity,
          0,
        ) || 0;
      return cumulativeCountOfMeals + numMealsForCartDelivery;
    },
    0,
  );
};
